module.exports = __webpack_public_path__ + "static/media/rci_generic_port.289b1fc4.jpg";